// extracted by mini-css-extract-plugin
export default {"imageContent":"ip-z","modal":"jp-z"};